export default "__VITE_ASSET__Cn4Y$dUG__"